import { sendEmail } from '@/api/recom/index';
import { formatNombre } from '@/services/general/general';

const oppLink = location.href;

export async function sendModifidationEmail(object, corps, id,
  commercial, client, societe, themeCampagne, emailCommercial) {
  let newSociete = '';
  if (societe) newSociete = ` de la société <strong>${societe}</strong>`;
  const newBody = `
    <div style="color: #7b899b; font-size: 14px; font-family: sans-serif">
      <div>${commercial}</div>
      <div> Votre client ${client} ${newSociete} demande des modifications sur la poposition ${themeCampagne} que vous lui avez envoyée.</div>
      <div>${corps}</div>
      <a href="${oppLink}" style="text-decoration:none"> <button style="background-color: #333B53; color: white; margin-left: auto; margin-right: auto; padding: 10px; font-size: 14px; display: flex; border-radius: 50px; border: none">Consulterla proposition</button></a>
    </div>`;
  const body = {
    objet: object,
    corps: newBody,
    from: 'support@quadra-diffusion.fr',
    to: [emailCommercial],
  };
  const response = await sendEmail(id, body);
  return response;
}

export async function sendValidationEmail(id, commercial, client, societe, themeCampagne, emailCommercial , panneaux) {
  let newSociete = '';
  let sectionPanneau = '';
  if (societe) newSociete = ` de la société <strong>${societe}</strong>`;
  const templatePanneau = `
    <div style="height: 100px; background-color: white; border: 1px solid #D6D6D6; margin-top: 10px;">
      <img style="display: inline-block; vertical-align: top; width: 100px; height: 100px;" src="{{img}}">
      <div style="display: inline-block; margin-left: 20px; margin-top: 30px;">
        {{adresse}}
        <br/>
        <span><strong>{{montant}}</strong></span>
      </div>
    </div>`;
  if (panneaux.length > 0) {
    let tabPanneaux = '';
    let montantTotal = 0;
    panneaux.forEach(panneau => {
      tabPanneaux += templatePanneau
        .replace('{{img}}', panneau.srcImg)
        .replace('{{adresse}}', panneau.adresseCommerciale)
        .replace('{{montant}}', formatNombre(afficheDetail(panneau).prixTotal))
        montantTotal +=  (afficheDetail(panneau).prixTotal); 
    });
    sectionPanneau =
      `<div style="color: #2C3E50; margin-bottom: 10px;">
        <strong>Sélection : </strong> <br/>
        ${tabPanneaux}
        <p style="text-align: end; color: #2C3E50"><strong>Total de la sélection : ${formatNombre(montantTotal)}</strong></p>
      </div>`
  }
  let newBody = `
    <div style="color:#5E738B; font-size: 14px; font-family:sans-serif">
      <img style="float: left" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MC43OTgiIGhlaWdodD0iODYiIHZpZXdCb3g9IjAgMCA4MC43OTggODYiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiNmMmYyZjI7fS5ie2ZpbGw6I2NkZDZlMDt9LmN7ZmlsbDojYWNiM2JhO30uZHtmaWxsOiM3YWM5NDM7fTwvc3R5bGU+PC9kZWZzPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MDMuMjIzIC0yMjkpIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MDMuMjIzIDIyOSkiPjxwYXRoIGNsYXNzPSJhIiBkPSJNNTUzLjg2MywyMjkuMTYySDUwOC41NTRhNS4zMyw1LjMzLDAsMCwwLTUuMzMxLDUuMzI5djcxLjk2MWE1LjMzMSw1LjMzMSwwLDAsMCw1LjMzMSw1LjMzMWg1MS45NzFhNS4zMzEsNS4zMzEsMCwwLDAsNS4zMzEtNS4zMzF2LTY1LjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MDMuMjIzIC0yMjguOTExKSIvPjxwYXRoIGNsYXNzPSJiIiBkPSJNNTM4Ljg3NywyNDEuMjQ0SDU0OC4xTDUzNS44NTQsMjI5djkuMjIxQTMuMDMzLDMuMDMzLDAsMCwwLDUzOC44NzcsMjQxLjI0NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00ODUuMjE0IC0yMjkpIi8+PHJlY3QgY2xhc3M9ImIiIHdpZHRoPSI1NC4zOCIgaGVpZ2h0PSIzLjc3OSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC4yNTYgMjIuMDA5KSIvPjxyZWN0IGNsYXNzPSJjIiB3aWR0aD0iMzUuMDciIGhlaWdodD0iMy43NzkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuMjU2IDExLjYwNikiLz48cmVjdCBjbGFzcz0iYiIgd2lkdGg9IjU0LjM4IiBoZWlnaHQ9IjMuNzc5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0LjI1NiAzMi4xMDkpIi8+PHJlY3QgY2xhc3M9ImMiIHdpZHRoPSIyMS45MTkiIGhlaWdodD0iMy43NzkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM2LjcxNyA0Mi41MTIpIi8+PC9nPjxwYXRoIGNsYXNzPSJkIiBkPSJNNTQ4LjM5MiwyOTUuMjczbC0xNy41MTUtMTMuMzY1LDUuNjQ4LTcuNCwxMC40LDcuOTM2LDE0LjY2LTE3LjcsNy4xNzIsNS45NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1LjI2MiAxOS43MjcpIi8+PC9nPjwvc3ZnPg==">
      <div>${client} ${newSociete} a validé la recommandation &#171;${themeCampagne}&#187; .</div>
      {{sectionPanneau}}
      <div style="margin-bottom: 10px;"> Vous pouvez consulter le détail de cette proposition en cliquant sur le lien suivant :</div>
      <a href="${oppLink}" style="text-decoration:none"> <button style="background-color: #333B53; color: white; margin-left: auto; margin-right: auto; padding: 10px; font-size: 14px; display: flex; border-radius: 50px; border: none">Consulter la proposition</button></a>
    </div>`;
  newBody = newBody.replace('{{sectionPanneau}}', sectionPanneau)
  const body = {
    objet: `${client} a validé une recommandation`,
    corps: newBody,
    from: 'support@quadra-diffusion.fr',
    to: [emailCommercial],
  };
  const response = await sendEmail(id, body);
  return response;
}

export async function sendRefusEmail(id, commercial, client, societe, themeCampagne, emailCommercial) {
  let newSociete = '';
  if (societe) newSociete = ` de la société <strong>${societe}</strong>`;
  const newBody = `
    <div style="color: #7b899b; font-size: 14px; font-family: sans-serif">
      <img style="float: left" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3My41OTMiIGhlaWdodD0iODYiIHZpZXdCb3g9IjAgMCA3My41OTMgODYiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiNmMmYyZjI7fS5ie2ZpbGw6I2NkZDZlMDt9LmN7ZmlsbDojYWNiM2JhO30uZHtmaWxsOiNkNDM4MzI7fTwvc3R5bGU+PC9kZWZzPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNDAgLTEyNikiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0MCAxMjYpIj48cGF0aCBjbGFzcz0iYSIgZD0iTTQ5My40NTYsMjI5LjE2MmgtNDQuMDVhNS4xODIsNS4xODIsMCwwLDAtNS4xODMsNS4xODFWMzA0LjNhNS4xODMsNS4xODMsMCwwLDAsNS4xODMsNS4xODNoNTAuNTI3YTUuMTgzLDUuMTgzLDAsMCwwLDUuMTgzLTUuMTgzVjI0MC44MjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NDQuMjIzIC0yMjguOTE4KSIvPjxwYXRoIGNsYXNzPSJiIiBkPSJNNDc5Ljc5MywyNDAuOWg4Ljk2NWwtMTEuOS0xMS45djguOTY1QTIuOTQ4LDIuOTQ4LDAsMCwwLDQ3OS43OTMsMjQwLjlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDI3LjYyMSAtMjI5KSIvPjxyZWN0IGNsYXNzPSJiIiB3aWR0aD0iNTIuODY5IiBoZWlnaHQ9IjMuNjc0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0LjEzNyAyMS4zOTcpIi8+PHJlY3QgY2xhc3M9ImMiIHdpZHRoPSIzNC4wOTYiIGhlaWdodD0iMy42NzQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuMTM3IDExLjI4NCkiLz48cmVjdCBjbGFzcz0iYiIgd2lkdGg9IjUyLjg2OSIgaGVpZ2h0PSIzLjY3NCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC4xMzcgMzEuMjE3KSIvPjxyZWN0IGNsYXNzPSJjIiB3aWR0aD0iMjEuMzEiIGhlaWdodD0iMy42NzQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM1LjY5NiA0MS4zMzEpIi8+PHBhdGggY2xhc3M9ImQiIGQ9Ik01MDIuMTU4LDI3My44MmwtNS44Mi01LjgyLTcuNzU5LDcuNzU5TDQ4MC44MiwyNjgsNDc1LDI3My44Mmw3Ljc1OSw3Ljc1OUw0NzUsMjg5LjMzOGw1LjgyLDUuODIsNy43NTktNy43NTksNy43NTksNy43NTksNS44Mi01LjgyLTcuNzU5LTcuNzU5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyOC41NjUgLTIwOS4xNTgpIi8+PC9nPjwvZz48L3N2Zz4=">
      <div>${commercial}</div>
      <div> Votre client ${client} ${newSociete} a <strong>refusé la proposition</strong> ${themeCampagne} que vous lui avez envoyée.</div>
      <div> Vous pouvez consulter le détail de cette proposition en cliquant sur le lien suivant :</div>
      <a href="${oppLink}" style="text-decoration:none"> <button style="background-color: #333B53; color: white; margin-left: auto; margin-right: auto; padding: 10px; font-size: 14px; display: flex; border-radius: 50px; border: none">Consulterla proposition</button></a>
    </div>`;
  const body = {
    objet: 'La proposition est refusée',
    corps: newBody,
    from: 'support@quadra-diffusion.fr',
    to: [emailCommercial],
  };
  const response = await sendEmail(id, body);
  return response;
}

function afficheDetail(panneau) {
  if (panneau.budgetProrata.prixNet || panneau.budgetProrata.tlpe
     || panneau.budgetProrata.fraisTechnique
     || panneau.budgetProrata.honorarires
     || panneau.budgetProrata.dateDebut
     || panneau.budgetProrata.dateFin) {
    return panneau.budgetProrata;
  }
  return panneau.budgetAnnuel;
}
